"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.logosProviderActions = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const _reduxjs_1 = require("../../utils/@reduxjs");
const api_1 = require("../../utils/api");
const REDUCER_KEY = 'logosProvider';
exports.initialState = (0, _reduxjs_1.getPreloadedState)(REDUCER_KEY, {
    logos: {
        COMPETITOR: {
            entries: {},
            fetchItems: api_1.requestInitialState,
        },
        TOURNAMENT: {
            entries: {},
            fetchItems: api_1.requestInitialState,
        },
        PLAYER: {
            entries: {},
            fetchItems: api_1.requestInitialState,
        },
    },
});
const logosProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchLogo(state, { payload }) {
            const { entityType } = payload;
            state.logos[entityType].fetchItems.loading = true;
        },
        fetchLogoSuccess(state, { payload }) {
            const { entityType, items } = payload.resData;
            const itemsMap = (0, _reduxjs_1.toIdsMap)(items, 'entityId');
            state.logos[entityType].entries = {
                ...state.logos[entityType].entries,
                ...itemsMap,
            };
            state.logos[entityType].fetchItems.loading = false;
        },
        fetchLogoError(state, { payload }) {
            const { entityType, ...errorInfo } = payload;
            state.logos[entityType].fetchItems.loading = false;
            state.logos[entityType].fetchItems.error = errorInfo;
        },
    },
});
exports.logosProviderActions = logosProviderSlice.actions, exports.reducer = logosProviderSlice.reducer, exports.sliceKey = logosProviderSlice.name;
//# sourceMappingURL=slice.js.map